import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { StudyGroupModalService } from '../../modals/study_groups_modal_service';
import { ICourseSection } from '../../study_group_interfaces';

export class StudyGroupJoinController {
  private section: ICourseSection;
  private onJoin: () => void;
  constructor(private ngStudyGroupModalService: StudyGroupModalService, private addUserToStudyGroupCommand: ICommand) {}
  joinStudyGroup(): void {
    this.ngStudyGroupModalService.showBusySpinner = true;
    this.addUserToStudyGroupCommand(this.section.id).then(() => {
      this.section.is_buddy = true;
      this.ngStudyGroupModalService.showBusySpinner = false;
      this.ngStudyGroupModalService.hide();
      if (_4.isFunction(this.onJoin)) {
        this.onJoin();
      }
    });
  }

  confirmJoining(): void {
    this.ngStudyGroupModalService.show({
      heading: 'Join Group',
      prompt: 'Interested in joining the group of Study Buddies for',
      className: ` ${this.section.courseTitle}-${this.section.cd}?`,
      content: `Other students in your class section will be able to see your email address and reach out to you via email. Is that OK?`,
      cancelButtonText: `Nevermind`,
      confirmButtonText: `Yes`,
      confirmationCallBack: this.joinStudyGroup.bind(this)
    });
  }
}

export class StudyGroupJoinComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-study-groups/src/components/study_group_join/study_group_join.html';
  public controller: any = StudyGroupJoinController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    section: '=',
    stretched: '<?',
    onJoin: '&?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/components/study_group_join/study_group_join.ts